import WifiIcon from '@mui/icons-material/Wifi';
import BoltIcon from '@mui/icons-material/Bolt';
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React from "react";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Chip from '@mui/material/Chip';
import SignalWifiConnectedNoInternet4Icon from '@mui/icons-material/SignalWifiConnectedNoInternet4';
import SatelliteIcon from '@mui/icons-material/Satellite';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PlaceIcon from '@mui/icons-material/Place';

const styles = {
    paper: {
      padding: '28px',
      marginTop: "40px",
      marginBottom: '40px',
    },
  };

function DisplayDetailsTable ({data}) {
const tableData = [
  {
    avatar: <CheckCircleIcon style={{ color: 'green' }}/>,
    name: "Locations Served with All Technologies",
    total: (data?.['underserved_locations_fiber']?.val ||0) + (data?.['unserved_locations_fiber']?.val ||0) +
    (data?.['underserved_locations_wireless'].val ||0)+(data?.['unserved_locations_wireless'].val ||0) +
    (data?.['unserved_locations_satellite'].val ||0)+(data?.['underserved_locations_satellite'].val ||0), 

    cost: (data?.['underserved_locations_fiber'].cost ||0) + (data?.['unserved_locations_fiber']?.cost ||0)
    + (data?.['underserved_locations_wireless'].cost ||0) + (data?.['unserved_locations_wireless'].cost ||0)
    + (data?.['unserved_locations_satellite'].cost ||0) + (data?.['underserved_locations_satellite'].cost ||0),

    underserved: (data?.['underserved_locations_fiber']?.val ||0) + 
    (data?.['underserved_locations_wireless']?.val ||0) +
    (data?.['underserved_locations_satellite']?.val ||0),

    underserved_percent: ((data?.['underserved_locations_fiber'].perc ||0)+
    (data?.['underserved_locations_wireless'].perc ||0)+
    (data?.['underserved_locations_satellite'].perc ||0)).toFixed(2),

    unserved: (data?.['unserved_locations_fiber'].val ||0)+ 
    (data?.['unserved_locations_wireless'].val ||0)+
    (data?.['unserved_locations_satellite'].val ||0),

    unserved_percent: ((data?.['unserved_locations_fiber'].perc ||0) + 
    (data?.['unserved_locations_wireless'].perc ||0) +
    (data?.['unserved_locations_satellite'].perc ||0)).toFixed(2),
  },
  {
    avatar: <BoltIcon style={{ color: '42a5f5' }}/>,
    name: "Locations Served with Fiber",
    total: (data?.['underserved_locations_fiber']?.val ||0) + (data?.['unserved_locations_fiber']?.val ||0),
    cost: (data?.['underserved_locations_fiber'].cost ||0) + (data?.['unserved_locations_fiber']?.cost ||0),
    underserved: data?.['underserved_locations_fiber']?.val ||0,
    underserved_percent: (data?.['underserved_locations_fiber'].perc ||0).toFixed(2),
    unserved: data?.['unserved_locations_fiber'].val ||0,
    unserved_percent: (data?.['unserved_locations_fiber'].perc ||0).toFixed(2),
  },
  {
    avatar: <WifiIcon style={{ color: '#7e57c2' }}/>,
    name: "Locations Served with Fixed Wireless",
    total: (data?.['underserved_locations_wireless'].val ||0)+(data?.['unserved_locations_wireless'].val ||0),
    cost: (data?.['underserved_locations_wireless'].cost ||0) + (data?.['unserved_locations_wireless'].cost ||0),
    underserved: data?.['underserved_locations_wireless']?.val ||0,
    underserved_percent: (data?.['underserved_locations_wireless'].perc ||0).toFixed(2),
    unserved: data?.['unserved_locations_wireless']?.val ||0,
    unserved_percent: (data?.['unserved_locations_wireless'].perc ||0).toFixed(2),
  },
  {
    avatar: <SatelliteIcon style={{ color: 'orange' }}/>,
    name: "Locations Served with Satellite",
    total: (data?.['unserved_locations_satellite'].val ||0)+(data?.['underserved_locations_satellite'].val ||0),
    cost: (data?.['unserved_locations_satellite'].cost ||0) + (data?.['underserved_locations_satellite'].cost ||0),
    underserved: data?.['underserved_locations_satellite']?.val ||0,
    underserved_percent: (data?.['underserved_locations_satellite'].perc ||0).toFixed(2),
    unserved: data?.['unserved_locations_satellite']?.val ||0,
    unserved_percent: (data?.['unserved_locations_satellite'].perc ||0).toFixed(2),
  },
  {
    avatar: <SignalWifiConnectedNoInternet4Icon style={{ color: 'red' }}/>,
    name: "Locations Not Served",
    total: (data?.['unserved_locations_not_connected'].val ||0)+(data?.['underserved_locations_not_connected'].val ||0),
    cost: (data?.['unserved_locations_not_connected'].cost ||0) + (data?.['underserved_locations_not_connected'].cost ||0),
    underserved: data?.['underserved_locations_not_connected']?.val ||0,
    underserved_percent: (data?.['underserved_locations_not_connected'].perc ||0).toFixed(2),
    unserved: data?.['unserved_locations_not_connected']?.val ||0,
    unserved_percent: (data?.['unserved_locations_not_connected'].perc ||0).toFixed(2),
  },
  {
    avatar: <PlaceIcon style={{ color: 'pink' }}/>,
    name: "Total Locations",
    total: (data?.['underserved_locations_fiber']?.val ||0) + (data?.['unserved_locations_fiber']?.val ||0) +
    (data?.['underserved_locations_wireless'].val ||0)+(data?.['unserved_locations_wireless'].val ||0) +
    (data?.['unserved_locations_satellite'].val ||0)+(data?.['underserved_locations_satellite'].val ||0)+
    (data?.['unserved_locations_not_connected'].val ||0)+(data?.['underserved_locations_not_connected'].val ||0), 

    cost: (data?.['underserved_locations_fiber'].cost ||0) + (data?.['unserved_locations_fiber']?.cost ||0)
    + (data?.['underserved_locations_wireless'].cost ||0) + (data?.['unserved_locations_wireless'].cost ||0)
    + (data?.['unserved_locations_satellite'].cost ||0) + (data?.['underserved_locations_satellite'].cost ||0)+
    (data?.['unserved_locations_not_connected'].cost ||0) + (data?.['underserved_locations_not_connected'].cost ||0),

    underserved: (data?.['underserved_locations_fiber']?.val ||0) + 
    (data?.['underserved_locations_wireless']?.val ||0) +
    (data?.['underserved_locations_satellite']?.val ||0)+
    (data?.['underserved_locations_not_connected']?.val ||0),

    underserved_percent: -1,

    unserved: (data?.['unserved_locations_fiber'].val ||0)+ 
    (data?.['unserved_locations_wireless'].val ||0)+
    (data?.['unserved_locations_satellite'].val ||0)+
    (data?.['unserved_locations_not_connected'].val ||0),

    unserved_percent: -1,
  },
];
  return (
    <div>
      <Paper elevation={8} style={styles.paper}>
        <Typography variant="h5">Details</Typography>
        <TableContainer>
          <Table responsive="true" borderless="true">
            <TableHead>
              <TableRow>
                <TableCell>Internet Connectivity Type</TableCell>
                <TableCell>Cost</TableCell>
                <TableCell>Total Locations</TableCell>
                <TableCell>Underserved Locations</TableCell>
                <TableCell>Unserved Locations</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {tableData.map((tdata, index) => (
                <TableRow key={index} className="border-top">
                  <TableCell>
                    <div className="d-flex align-items-center p-2">
                      {tdata.avatar}
                      <div className="ms-3">
                        <Typography variant="h6" className="mb-0">
                          {tdata.name}
                        </Typography>
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>{`$${tdata.cost.toLocaleString()}`}</TableCell>
                  <TableCell>{tdata.total.toLocaleString()}</TableCell>

                  
                  <TableCell>
                    {tdata.underserved.toLocaleString()}
                    {tdata.underserved_percent >= 0 && (
                    <Chip label={`${tdata.underserved_percent}%`} style={{ marginLeft: '20px', backgroundColor: '#616161', color: 'white' }} />
                    )}
                    </TableCell>

                    <TableCell>
                    {tdata.unserved.toLocaleString()}
                    {tdata.unserved_percent >= 0 && (
                    <Chip label={`${tdata.unserved_percent}%`} style={{ marginLeft: '20px', backgroundColor: '#616161', color: 'white' }} />
                    )}
                    </TableCell>


                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};

export default DisplayDetailsTable;